<div class="main">
  <p>Hold og data vil ikke være tilgængeligt for dig eller andre lærere.</p>
</div>
<div class="footer">
  <lru-button [variant]="'lounge'" [theme]="'white'" [hollow]="true" (click)="onClickClose()()">Annuller</lru-button>
  <lru-button [variant]="'lounge'" [theme]="'primary-teacher'" (click)="onClickDelete()">Ja, slet hold</lru-button>
</div>
<lru-team-header [closeFunc]="onClickClose()" [header]="'Slet ' + teamEdit.title"></lru-team-header>
